module.exports = __webpack_public_path__ + "img/scroll_t.26d01b46.svg";